<template>
  <div>
    <b-row>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.term_register_code}: `"
            :rules="$v.code.$params"
          />
          <b-form-input
            v-model="$v.code.$model"
            type="text"
            minLength="3"
            maxLength="10"
            autocomplete="off"
            :state="$v.code.$dirty ? !$v.code.$error : null"
          />
          <b-form-invalid-feedback
            :state="$v.code.$dirty ? !$v.code.$error : null"
          >
            <div v-if="!$v.code.required">
              {{ $lang.error_required | replace($lang.term_register_code) }}
            </div>
            <div v-if="!$v.code.numeric">
              {{ $lang.error_numeric | replace($lang.term_register_code) }}
            </div>
            <div v-if="$v.code.numeric && !$v.code.minLength">
              {{ $lang.error_min_value | replace($lang.term_register_code, 3) }}
            </div>
            <div v-if="$v.code.numeric && !$v.code.maxLength">
              {{ $lang.error_max | replace($lang.term_register_code, 10) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.national_code}: `"
            :rules="$v.national_code.$params"
          />
          <b-form-input
            v-model="$v.national_code.$model"
            type="text"
            autocomplete="off"
            maxLength="10"
            :state="$v.national_code.$dirty ? !$v.national_code.$error : null"
          />
          <b-form-invalid-feedback
            :state="$v.national_code.$dirty ? !$v.national_code.$error : null"
          >
            <div v-if="!$v.national_code.required">
              {{ $lang.error_required | replace($lang.national_code) }}
            </div>
            <div v-if="!$v.national_code.numeric">
              {{ $lang.error_numeric | replace($lang.national_code) }}
            </div>
            <div
              class="invalid-feedback"
              v-if="
                ($v.national_code.numeric && !$v.national_code.minLength) ||
                !$v.national_code.maxLength
              "
            >
              {{ $lang.error_max | replace($lang.national_code, 10) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="text-right pt-3">
        <b-button
          variant="success"
          @click="submit"
          v-if="isAdmin(parentPermissions)"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="close"
        >
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { pathOr } from "ramda";
import {
  required,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { isAdmin } from "@/shared/utils";

export default {
  validations: {
    code: {
      required,
      numeric,
      minLength: minLength(3),
      maxLength: maxLength(10),
    },
    national_code: {
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: null,
    },
    termCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      code: null,
      national_code: null,
    };
  },
  watch: {
    item(value) {
      value && this.fetchData();
    },
  },
  methods: {
    pathOr,
    isAdmin,
    close() {
      this.$emit("close");
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      let payload = {
        code: this.code,
        national_code: this.national_code,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.code = pathOr(null, ["code"], this.item);
        this.national_code = pathOr(null, ["national_code"], this.item);
      }
    },
  },
};
</script>